import { useAuth0 } from '@auth0/auth0-react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@ficatranquilo/contabilidade.com-ui'
import { clearActiveCompany } from '../../../helpers/activeCompany'
import { PublicLoading, PublicPage } from '../Common/PublicPage'

export default function Token() {
  const navigate = useNavigate()
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0()
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    const handleAuth = async () => {
      // Aguarda o Auth0 terminar de carregar
      if (isLoading) {
        return
      }

      // Se não está autenticado após o loading, redireciona para login
      if (!isAuthenticated) {
        console.error('Não autenticado após callback do Auth0')
        navigate('/auth/entrar')
        return
      }

      try {
        const accessToken = await getAccessTokenSilently({
          detailedResponse: true
        })

        // O que precisamos é o access_token para fazer chamadas à API
        let tokenToSave = null

        if (accessToken && accessToken.access_token) {
          tokenToSave = accessToken.access_token
        } else if (typeof accessToken === 'string') {
          tokenToSave = accessToken
        } else {
          throw new Error('Token não encontrado na resposta do Auth0')
        }

        localStorage.setItem('idToken_ow', tokenToSave)

        // A cada login quem tem mais de uma empresa escolhe de novo; o reload e as
        // abas novas é que reaproveitam a última empresa
        clearActiveCompany()
        localStorage.removeItem('viewMode_ow')

        // Verificar se tem token de convite pendente
        const inviteToken = localStorage.getItem('invite_token_ow')

        // Aguarda um pouco para garantir que o token foi salvo
        setTimeout(() => {
          if (inviteToken) {
            // Redirecionar de volta para a página de convite
            navigate(`/register/e/${inviteToken}`)
          } else {
            navigate('/')
          }
        }, 300)
      } catch (err) {
        console.error('Erro ao obter token:', err?.message)
        sessionStorage.clear()
        localStorage.removeItem('idToken_ow')
        localStorage.removeItem('uid_ow')
        localStorage.removeItem('user_ow')
        setFailed(true)
      }
    }

    handleAuth()
  }, [isAuthenticated, isLoading, getAccessTokenSilently, navigate])

  if (failed) {
    return (
      <PublicPage
        title="Não foi possível entrar"
        description="Tente de novo. Se continuar, fale com o suporte da Contabilidade.com."
        actions={<Button $text="Tentar novamente" $variant="primary" $action={() => navigate('/auth/entrar')} />}
      />
    )
  }

  return <PublicLoading text="Entrando" />
}
